module.exports = __webpack_public_path__ + "static/media/xuanqi_match_01.97e937bd.png";